export default __webpack_public_path__ + "static/media/260.fb3ded9b.svg";